"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newrelicReporter = void 0;
function newrelicReporter(info) {
    var _a;
    const newrelic = window.newrelic;
    (_a = newrelic === null || newrelic === void 0 ? void 0 : newrelic.addRelease) === null || _a === void 0 ? void 0 : _a.call(newrelic, info.service, info.version);
    const reporter = {
        trackEvent: function (event) {
            var _a;
            (_a = newrelic === null || newrelic === void 0 ? void 0 : newrelic.addPageAction) === null || _a === void 0 ? void 0 : _a.call(newrelic, event.message, {
                ...event.metadata,
                ...event.tags,
                ...event.metrics,
                ...(event.level ? { level: event.level } : {}),
            });
        },
        addBreadcrumb: function (breadcrumb) {
            var _a;
            (_a = newrelic === null || newrelic === void 0 ? void 0 : newrelic.addPageAction) === null || _a === void 0 ? void 0 : _a.call(newrelic, breadcrumb.message, {
                ...breadcrumb.metadata,
                ...(breadcrumb.category ? { category: breadcrumb.category } : {}),
            });
        },
        addMetadata: function (metadata) {
            var _a;
            for (const [key, value] of Object.entries(metadata)) {
                (_a = newrelic === null || newrelic === void 0 ? void 0 : newrelic.setCustomAttribute) === null || _a === void 0 ? void 0 : _a.call(newrelic, key, value);
            }
        },
        setUser: function (user) {
            reporter.addMetadata({ user });
        },
        setRouteName: function (routeName) {
            var _a;
            (_a = newrelic === null || newrelic === void 0 ? void 0 : newrelic.setCurrentRouteName) === null || _a === void 0 ? void 0 : _a.call(newrelic, routeName);
        },
        setPageName: function (pageName) {
            var _a;
            (_a = newrelic === null || newrelic === void 0 ? void 0 : newrelic.setPageViewName) === null || _a === void 0 ? void 0 : _a.call(newrelic, pageName);
        },
        reportError: function (error, metadata) {
            var _a;
            (_a = newrelic === null || newrelic === void 0 ? void 0 : newrelic.noticeError) === null || _a === void 0 ? void 0 : _a.call(newrelic, error, metadata);
        },
        recordSession: function () { },
        recordSessionStop: function () { },
    };
    return reporter;
}
exports.newrelicReporter = newrelicReporter;
//# sourceMappingURL=newrelicReporter.js.map